<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.01.30</b> - Data/code/infrastructure improvements</p>
    <ul class="ml-5 pb-4 list-outside list-disc text-cyan-300">
      <li>
        Refactored caverns run data so it won't be lost on network disconnects or closing
        the app.
      </li>
      <li>Fixed a bunch of caverns memory/CPU leaks & other performance issues.</li>
      <li>Moved backend to a new cloud provider with better performance & auto-scaling.</li>
    </ul>
  </div>
</template>
